import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";

import "./index.scss";

const numberOfItemsPerRow = [5, 2, 3, 4, 3, 4];

const useStyles = makeStyles((theme) => ({
  loadingTableContainer: {
    backgroundColor: theme.palette.background.paper,
  },
  loadingTableRowContainer: {
    height: 61,
    display: "flex",
    padding: "0 15px",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  skeletonLoadingPulse: {
    backgroundColor: "rgba(111, 111, 111, 0.2)",
  },
}));

const getRowClassName = (index) => {
  if (index === 0)
    return "loadingTableRowContainer darkerBackground"; // header in old table is this color
  else if (index % 2 !== 0)
    return "loadingTableRowContainer darkBackground"; // every other row in old table is this color
  else return "loadingTableRowContainer whiteBackground";
};

const LoadingTable = ({ isMaterial }) => {
  const classes = useStyles();
  return (
    // material check and secondary loading table can be removed
    // once all pages are moved to the new material UI standard
    isMaterial ? (
      <div className={classes.loadingTableContainer}>
        {numberOfItemsPerRow.map((num, i) => (
          <div key={i} className={classes.loadingTableRowContainer}>
            <Skeleton height={20} width={num * 200} />
          </div>
        ))}
      </div>
    ) : (
      <div className={"loadingTableOuterContainer"}>
        {numberOfItemsPerRow.map((num, i) => (
          <div key={i} className={getRowClassName(i)}>
            <Skeleton
              height={20}
              width={num * 200}
              className={classes.skeletonLoadingPulse}
            />
          </div>
        ))}
      </div>
    )
  );
};

export default LoadingTable;
